/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { TableSpacing } from '..';

export interface TableTdSignature {
  // The arguments accepted by the component
  Args: {
    textAlign?: 'left' | 'right';
    spacing?: TableSpacing;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLTableCellElement;
}

export default templateOnly<TableTdSignature>();
